import React, { useState } from "react";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalInfoCard,
    StandardModalSection,
    StandardModalText,
    Toast
} from "src/components";
import { requestProUpdate } from "../api/emailCampaignsApi";

export default function DowngradePlanDisplayModal({
    onBack,
    downgradePlan,
    purchasedEmailPro,
    effectiveDate,
    price,
    onSuccess
}) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const formattedDate = new Date(effectiveDate).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });

    const requestUpdate = async () => {
        try {
            setIsSubmitting(true);
            await requestProUpdate({
                newPlanUuid: downgradePlan.uuid,
            });
            await onSuccess();
            setIsConfirmed(true);
        } catch (err) {
            Toast.error(err.getApiErrorDetails().message);
            console.error("Downgrade failed", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <StandardModal
            open={true}
            onClose={onBack}
            title={isConfirmed ? "Plan Change Confirmed!" : "Confirm Plan Change"}
            description={isConfirmed
                ? "Your email plan downgrade has been successfully applied."
                : "You're about to schedule a downgrade for your Email plan."}
            widthMode="large"
            footer={(
                <StandardModalActionGroup $pushRight>
                    {!isConfirmed && (
                        <StandardModalActionButton onClick={onBack}>
                            Close
                        </StandardModalActionButton>
                    )}
                    <StandardModalActionButton
                        $variant="primary"
                        disabled={isSubmitting}
                        onClick={isConfirmed ? onBack : requestUpdate}
                        width={isConfirmed ? "12rem" : "10.5rem"}
                    >
                        {isConfirmed ? "Go to Email Campaigns" : isSubmitting ? "Processing..." : "Confirm Downgrade"}
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection gap="1rem">
                <StandardModalInfoCard>
                    <StandardModalText weight="700" color="#171A22">Plan Change</StandardModalText>
                    <StandardModalText>{purchasedEmailPro?.addon?.title} to {downgradePlan?.title}</StandardModalText>
                </StandardModalInfoCard>
                <StandardModalInfoCard>
                    <StandardModalText weight="700" color="#171A22">Effective {isConfirmed ? "From" : "Date"}</StandardModalText>
                    <StandardModalText>
                        {isConfirmed ? `At your next renewal (${formattedDate})` : `From your renewal date (${formattedDate})`}
                    </StandardModalText>
                </StandardModalInfoCard>
                {!isConfirmed && (
                    <StandardModalInfoCard>
                        <StandardModalText weight="700" color="#171A22">Charges Today</StandardModalText>
                        <StandardModalText>AUD ${price}</StandardModalText>
                    </StandardModalInfoCard>
                )}
                <StandardModalInfoCard background="var(--calendar-surface-secondary, #F3F5FB)">
                    <StandardModalText weight="700" color="#171A22">{isConfirmed ? "What's Changed" : "This Means"}</StandardModalText>
                    <StandardModalText>
                        {isConfirmed
                            ? "Your email sending limits will be updated to match your new plan at your next renewal. Your campaigns and audiences remain saved, and you can upgrade again whenever you need higher sending limits."
                            : "Your current plan stays active until renewal. The new plan starts automatically on your renewal date, and no refund is issued for unused time on the current plan."}
                    </StandardModalText>
                </StandardModalInfoCard>
                <StandardModalText size="0.875rem">
                    {isConfirmed
                        ? "Your subscription will renew with your new email plan on your next billing date."
                        : "You can upgrade again at any time before your renewal."}
                </StandardModalText>
            </StandardModalSection>
        </StandardModal>
    );
}
